import { render, staticRenderFns } from "./StudentDevelopmentReportOld.vue?vue&type=template&id=568d5520&scoped=true"
import script from "./StudentDevelopmentReportOld.vue?vue&type=script&lang=js"
export * from "./StudentDevelopmentReportOld.vue?vue&type=script&lang=js"
import style0 from "./StudentDevelopmentReportOld.vue?vue&type=style&index=0&id=568d5520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568d5520",
  null
  
)

export default component.exports